import React, { PureComponent } from 'react';

import Quote from 'shared/components/icon/Quote';
import { getText } from 'shared/utils/Text';

export default class SportAnalysisInfo extends PureComponent {
  render() {
    return (
      <div className="sport-analysis">
        <div className="sport-analysis-title">
          <Quote />
          <h2>{getText('sport-analysis-title')}</h2>
        </div>
        <p className="sport-analysis-subtitle">
          {getText('sport-analysis-info')}
        </p>
      </div>
    );
  }
}
